'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ServiceType = require('./ServiceType');

var _ServiceType2 = _interopRequireDefault(_ServiceType);

var _ServiceBase2 = require('./ServiceBase');

var _ServiceBase3 = _interopRequireDefault(_ServiceBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var LocalService = function (_ServiceBase) {
  (0, _inherits3.default)(LocalService, _ServiceBase);

  /**
   * @param {string} name
   * @param {string[]} dependencies
   */
  function LocalService(name) {
    var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    (0, _classCallCheck3.default)(this, LocalService);
    return (0, _possibleConstructorReturn3.default)(this, (LocalService.__proto__ || (0, _getPrototypeOf2.default)(LocalService)).call(this, _ServiceType2.default.LOCAL, name, dependencies));
  }

  return LocalService;
}(_ServiceBase3.default);

exports.default = LocalService;